export interface Coordinates {
  lat: number
  lon: number
}

export function requestLocation(): Promise<Coordinates> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'))
      return
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
        }),
      (err) => reject(new Error(err.message)),
      { timeout: 10_000, maximumAge: 60_000 },
    )
  })
}
